// Lightweight shared store for saved/bookmarked listings (Increment 18).
import { useSyncExternalStore } from "react";
import { api, getToken } from "./api";

let keys = new Set<string>();
let loaded = false;
let loading: Promise<void> | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
const k = (kind: string, refId: string) => `${kind}:${refId}`;

export function ensureSavedLoaded() {
  if (loaded || loading) return loading ?? Promise.resolve();
  if (!getToken()) { loaded = true; return Promise.resolve(); }
  loading = api.savedKeys().then((list) => { keys = new Set(list); loaded = true; emit(); }).catch(() => { loaded = true; }).finally(() => { loading = null; });
  return loading;
}
export function resetSaved() { keys = new Set(); loaded = false; emit(); }

export async function toggleSaved(kind: string, refId: string): Promise<boolean> {
  const key = k(kind, refId);
  const wasSaved = keys.has(key);
  // optimistic
  const next = new Set(keys);
  wasSaved ? next.delete(key) : next.add(key);
  keys = next; emit();
  try {
    if (wasSaved) await api.unsaveListing(kind, refId);
    else await api.saveListing(kind, refId);
  } catch {
    // revert on failure
    const revert = new Set(keys);
    wasSaved ? revert.add(key) : revert.delete(key);
    keys = revert; emit();
  }
  return !wasSaved;
}

function subscribe(cb: () => void) { listeners.add(cb); return () => listeners.delete(cb); }
export function useIsSaved(kind: string, refId: string): boolean {
  return useSyncExternalStore(subscribe, () => keys.has(k(kind, refId)), () => false);
}
